import React, { useRef, useEffect } from 'react'
import { Box, Container, Typography, Hidden } from '@material-ui/core'
import { Image, Transformation } from 'cloudinary-react'

import { MEDIUM_SIZE } from 'assets/CloudinaryURLHelper'
import PageWrapper from 'shared/wrappers/PageWrapper/PageWrapper'
import { useStyles } from './StartupsLandingPage_style'
import Button from 'components/Button/Button'
import HorizontalCardsSlider from 'shared/components/HorizontalCardsSlider/HorizontalCardsSlider'
import CompanyCard from 'cards/CompanyCard/CompanyCard'
import StartupsHelmet from 'helmets/StartupsHelmet'

const TYPEFORM_SCHEDULER_LINK = 'https://studentbe-c482a9.pipedrive.com/scheduler/YoLQaLUj/meeting'

const StartupsLandingPage = (props) => {
    const classes = useStyles()
    const { startups } = props
    const iframeRef = useRef(null)

    useEffect(() => {
        iframeRef.current.src = TYPEFORM_SCHEDULER_LINK
    }, [])

    return (
        <PageWrapper disableFooterLists>
            <StartupsHelmet />
            <Box className={classes.bannerContainer}>
                <Box className={classes.imageContainer}>
                    <Hidden smDown>
                        <Box className={classes.imageBox}>
                            <Image
                                cloudName='studentbe'
                                publicId='assets/startups-meeting'
                                alt='student.be startups meeting.'
                                className={classes.image}
                            >
                                <Transformation flags='progressive' fetchFormat='auto' quality='auto:best' crop='fill' />
                            </Image>
                        </Box>
                    </Hidden>
                    <Box className={classes.imageTextBox}>
                        <Typography variant='h1' className={classes.titlePage}>
                            Start-ups, let's level up
                        </Typography>
                        <Typography variant='h3' className={classes.subtitlePage}>
                            Bereik 500.000+ gemotiveerde studenten en young professionals doorheen heel België.
                        </Typography>
                    </Box>
                </Box>
            </Box>
            <Container maxWidth='md'>
                <Box className={classes.keyInfoContainer}>
                    <Box className={classes.keyInfoLeftSideContainer}>
                        <Box className={classes.keyInfoLeftSide}>
                            <Typography variant='h1' component='h2'>
                                Klinkt dit herkenbaar?
                            </Typography>
                            <Typography variant='body1' className={classes.fontSize16}>
                                <ul>
                                    <li>Moeite om gemotiveerd talent te vinden zonder torenhoge rekruteringskosten?</li>
                                    <li>Jouw vacature verdwijnt tussen de massa op grote jobboards?</li>
                                    <li>Geen tijd of middelen om een uitgebreid HR-proces op te zetten?</li>
                                </ul>
                            </Typography>
                            <Typography variant='body1' className={classes.fontSize16}>
                                Geen zorgen. Wij hebben de oplossing die wel werkt voor jouw start-up.
                            </Typography>
                            <Typography variant='h1' component='h2'>
                                Wat is Student?
                            </Typography>
                            <Typography variant='body1' className={classes.fontSize16}>
                            Student is het grootste Belgische platform dat studenten en young professionals verbindt met bedrijven. We zijn meer dan alleen een jobsite. We helpen jou slim groeien door jouw rechtstreeks toegang te geven tot jong, gemotiveerd talent. 
                            </Typography>
                            <Box className={classes.registrationButtonBox1}>
                                <Button
                                    className={classes.registrationButton}
                                    color='secondary'
                                    href={TYPEFORM_SCHEDULER_LINK}
                                    target='_blank'
                                >
                                    Plan nu je gratis demo in
                                </Button>
                            </Box>
                        </Box>
                    </Box>
                    <Box className={classes.keyInfoRightSide}>
                        <Hidden smDown>
                            <Image
                                className={classes.introImage}
                                cloudName="studentbe"
                                publicId='assets/startups-students'
                                alt='busines school image'
                            >
                                <Transformation flags="progressive" fetchFormat="auto" width={MEDIUM_SIZE} quality="auto:best" crop="fill" />
                            </Image>
                        </Hidden>
                    </Box>
                </Box>
                <Box className={classes.mapContainer} my={5}>
                    <Box className=''>
                        <Typography variant='h1' component='h2'>
                            Overal waar jong talent is, daar zijn wij.
                        </Typography>
                        <Typography variant='body1' className={classes.fontSize16}>
                            We zijn actief op elke campus in België – van hogeschool tot universiteit – en brengen jouw bedrijf in contact met de beste talenten.
                        </Typography>
                    </Box>
                    <Box className={classes.mapBox}>
                        <Image
                            className={classes.mapImage}
                            cloudName="studentbe"
                            publicId='assets/schools-map'
                            alt='busines school image'
                        >
                            <Transformation flags="progressive" fetchFormat="auto" width={MEDIUM_SIZE} quality="auto:best" crop="fill" />
                        </Image>
                    </Box>
                </Box>
                <Box className={classes.extraInfoContainer} my={5}>
                    <Box>
                        <Typography variant='h1' component='h2'>
                            Exclusief aanbod: Boost je Start-up met de Student licentie
                        </Typography>
                    </Box>
                    <Box my={2}>
                        <Typography variant='body1' className={classes.fontSize16}>
                            Wil je het maximale uit je rekruteringsinspanningen halen? Kies dan voor onze exclusieve licentie en geef je start-up een voorsprong in de war for talent.
                        </Typography>
                    </Box>
                    <Box my={2}>
                        <Typography variant='h1' component='h2'>
                            Wat krijg je?
                        </Typography>
                    </Box>
                    <Box my={2}>
                        <ul>
                            <li>
                                <Typography variant='body1' className={classes.fontSize16}>
                                    <span className={classes.spanBold}>Een bedrijfspagina: </span>
                                    Volledige controle over je vacatures en zichtbaarheid
                                </Typography>
                            </li>
                            <li>
                                <Typography variant='body1' className={classes.fontSize16}>
                                    <span className={classes.spanBold}>Bereik van 500.000+ studenten & young professionals: </span>
                                    Direct in contact met jong talent dat klaarstaat om impact te maken
                                </Typography>
                            </li>
                            <li>
                                <Typography variant='body1' className={classes.fontSize16}>
                                    <span className={classes.spanBold}>Onbeperkt vacatures plaatsen: </span>
                                    Voor stages, studentenjobs én startersfuncties
                                </Typography>
                            </li>
                        </ul>
                    </Box>
                    <Box>
                        <Typography variant='h1' component='h2'>
                            Speciaal aanbod: tijdelijk beschikbaar
                        </Typography>
                    </Box>
                    <Box my={2}>
                        <Typography variant='body1' className={classes.fontSize16}>
                        Teken <span className={classes.spanBold}>vóór 15 mei</span> en krijg dit alles voor slechts <span className={classes.spanBold}>€490 voor een volledig jaar</span>.
                        Mis deze kans niet. Plan je gratis demo en ontdek hoe snel je talent kunt aantrekken.
                        </Typography>
                    </Box>
                    <Box className={classes.registrationButtonBox2}>
                        <Button
                            className={classes.registrationButton}
                            color='secondary'
                            href={TYPEFORM_SCHEDULER_LINK}
                            target='_blank'
                        >
                            Plan nu je gratis demo in
                        </Button>
                    </Box>
                </Box>
                <Box mt={4} mb={2}>
                    <Typography variant='h1' component='h2'>
                        250 start-ups gingen jou voor. Waar wacht jij nog op?
                    </Typography>
                </Box>
                <Box my={2}>
                    <Typography variant='body1' className={classes.fontSize16}>
                        250 start-ups vertrouwen al op Student om hun groeipijnen op te lossen en het juiste talent aan te trekken. Van innovatieve tech-start-ups tot snelgroeiende scale-ups.
                        Ze kozen allemaal voor een slimme, kostenefficiënte manier om jong talent te vinden.
                    </Typography>
                </Box>
                <Container disableGutters maxWidth='lg' className={classes.sliderContainer}>
                    <HorizontalCardsSlider wrappedArrows shift={500}>
                        {startups.map((startup, index) => {
                            return (
                                <Box key={`company-card-${index}`} className={classes.companyCardBox}>
                                    <CompanyCard
                                        company={startup}
                                    />
                                </Box>
                            )
                        })}
                    </HorizontalCardsSlider>
                </Container>
                <Box mt={4} mb={2}>
                    <Typography variant='h1' component='h2'>
                        Plan nu je gratis demo in
                    </Typography>
                </Box>
                <Box my={2}>
                    <Typography variant='body1' className={classes.fontSize16}>
                        Sluit je aan bij de community van groeiende start-ups en ervaar zelf het verschil.
                        Plan je gratis demo en ontdek hoe jouw start-up de volgende successtory kan zijn
                    </Typography>
                </Box>
                <Box className={classes.pipedriveSchedule}>
                    <iframe
                        ref={iframeRef}
                        title="Pipedrive Scheduler Embed"
                        frameBorder="0"
                        className={classes.pipedriveScheduleFrame}
                        style={{ }}
                        allowFullScreen
                    ></iframe>
                </Box>
            </Container>
        </PageWrapper>
    )
}

export default StartupsLandingPage
